module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "center big-padding"
  }, [_vm._v("\n    Souhaitez-vous désactiver le maitrise "), _c('strong', [_vm._v(_vm._s(_vm.maitrise.nom) + " " + _vm._s(_vm.maitrise.prenom) + " ")]), _vm._v(" - "), _c('strong', [_vm._v(_vm._s(_vm._f("arrondissementName")(_vm.maitrise.arrondissement_id)))]), _vm._v(" ? "), _c('br'), _vm._v("Ce compte ne pourra alors plus accéder à l'application.\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.confirm()
      }
    }
  }, [_vm._v("\n      Désactiver\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n      Annuler\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-67e2a17a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/maitrises/MaitrisesDelete.vue
// module id = 2111
// module chunks = 2